import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

type JWT_Payload = {
    exp: number;
    iat: number;
};

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private readonly EXPR_TOKEN_KEY = '_token_expr_ms';

    constructor(private apiService: ApiService) {}

    async refreshAuthentication(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.apiService
                .refreshAuth()
                .then(data => {
                    try {
                        const tokenInfo = this.parseJwt(data.accessToken);
                        sessionStorage.setItem(
                            this.EXPR_TOKEN_KEY,
                            String(tokenInfo.payload.exp * 1000)
                        );
                    } catch (err: any) {
                        throw new Error(err);
                    }

                    resolve(true);
                })
                .catch(error => {
                    console.error('Token refresh failed:', error);
                    reject(error);
                });
        });
    }

    isTokenValid() {
        const exprTime = sessionStorage.getItem(this.EXPR_TOKEN_KEY);
        if (exprTime) {
            return new Date(Number(exprTime)) > new Date();
        }
        return false;
    }

    // This method does not validate the token, it only parses out the content, assuming it is a properly formatted JWT
    parseJwt = (token: string) => {
        try {
            const parts = token.split('.');
            return {
                header: JSON.parse(atob(parts[0])),
                payload: JSON.parse(atob(parts[1])) as JWT_Payload,
                signature: parts[2],
            };
        } catch (e) {
            throw new Error('Error parsing JWT.');
        }
    };
}
